import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Users, Database, Shield, Bell, Palette } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Configuraciones = () => {
  const navigate = useNavigate();

  const configSections = [
    {
      title: "Gestión de Usuarios",
      description: "Administrar usuarios y asignar roles",
      icon: Users,
      color: "bg-viable-blue",
      onClick: () => navigate('/gestion-usuarios'),
    },
    {
      title: "Configuración de Roles",
      description: "Definir permisos y crear nuevos roles",
      icon: Shield,
      color: "bg-viable-orange",
      onClick: () => navigate('/configuracion-roles'),
    },
    {
      title: "Base de Datos",
      description: "Configuración y mantenimiento de la base de datos",
      icon: Database,
      color: "bg-viable-green",
      onClick: () => navigate('/configuracion-base-datos'),
    },
    {
      title: "Notificaciones",
      description: "Configurar alertas y notificaciones del sistema",
      icon: Bell,
      color: "bg-accent",
      onClick: () => navigate('/configuracion-notificaciones'),
    },
    {
      title: "Manual de Marca",
      description: "Guía visual de identidad, colores e iconografía",
      icon: Palette,
      color: "bg-purple-500",
      onClick: () => navigate('/manual-marca'),
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card/95 backdrop-blur-md shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/home')}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Volver
            </Button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Configuraciones del Sistema</h1>
              <p className="text-sm text-muted-foreground">Panel de administración y configuración</p>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {configSections.map((section) => {
            const IconComponent = section.icon;
            return (
              <Card 
                key={section.title}
                className="group cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg border-2 hover:border-primary/50"
                onClick={section.onClick}
              >
                <CardHeader className="space-y-3">
                  <div className={`w-14 h-14 rounded-full ${section.color} flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300`}>
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl group-hover:text-primary transition-colors">
                    {section.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm leading-relaxed">
                    {section.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default Configuraciones;
